import React from 'react';

import { Heading } from '../../style/heading';

//import assets
import Img from '../../assets/img/tiavina.jpg';

//import styled
import {
    StyledContainer,
    StyledFlexContainer,
    StyledContent,
    StyledPic,
    StyledAvatar
} from './About_styled';



export default class About extends React.Component {
   
    render() {

        return (
            
            <StyledContainer>
                <Heading> A propos </Heading>
                <StyledFlexContainer>
                    <StyledContent>
                        
                    Je m’appelle Tiavina j’ai 25 ans et je suis célibataire.
                    Je dirais que ce qui me caractérise est la créativité, l’organisation et l’autonomie. 
                    Mon organisation très poussée a toujours été pour moi le moyen d’atteindre les objectifs fixés ou d’ajuster mes actions pour y parvenir.
                    Bien sûr j’aime le travail en équipe mais je sais également évoluer dans des missions en totale autonomie. 
                    D’ailleurs je continue de me former chaque jour en autodidacte.
                    
                    </StyledContent>
                    <StyledPic>

                        <StyledAvatar src={Img} />

                    </StyledPic>
                </StyledFlexContainer>
            </StyledContainer>
            
        );
    }
}